import Card from "@mui/material/Card";

interface Props {
  header: string;
  description: string;
  src: any;
  footerText: string; // Add a new prop for the footer text
}

function PromotionCard({ header, description, src, footerText }: Props) {
  return (
    <Card
    className="flex flex-col bg-plainGreen cursor-pointer border-none shadow-none mb-2 w-full p-4"
    style={{ width: "100%" }}
  >
    {/* First row: Image */}
    <div className="flex justify-between items-center mb-2">
      <div className="flex items-center">
        {/* <img src={src} alt="Promotion icon" className="w-8 h-8" /> */}
        <span className="font-bold md:text-base text-base opacity-75">
          {header}
        </span>
      </div>

      <div>
        {" "}
        <span className="text-xs opacity-75 font-bold">
          {footerText} Points
        </span>
      </div>
    </div>

    {/* Second row: Description and footer text */}
    <div className="flex flex-row justify-between items-center">
      <span className="text-xs opacity-75 ml-1">{description}</span>

      <button
        style={{ borderRadius: "15px", cursor: "default", fontSize: "10px" }}
        className="bg-customBlue text-white rounded-full w-[30%] py-1 px-2"
      >
        Redeem
      </button>
    </div>
  </Card>
  );
}

export default PromotionCard;
